// pt-BR for the wave-2 strings (complete for every key of en-wave2.ts, checked by the type).
import type { enWave2 } from "./en-wave2.ts";

export const ptBRWave2: Record<keyof typeof enWave2, string> = {
  "common.actions": "Ações",
  "common.edit": "Editar",
  "common.yes": "Sim",
  "common.no": "Não",

  "err.blockedExternal": "Bloqueado — integração externa não habilitada",
  "err.blockedExternalBody": "Integração não habilitada — requer credenciais e aprovação explícita. Nada foi tentado no servidor.",
  "err.policyDenied": "Recusado pela política",
  "err.realProviderBody": "Chamadas a provedores reais exigem aprovação explícita por integração. Nenhuma requisição foi enviada ao provedor e nenhum token foi usado.",
  "err.versionConflict": "Alterado por outra pessoa",
  "err.impediments": "Ainda não é possível — impedimentos",
  "err.validation": "Alguns campos não são válidos",
  "err.refused": "A solicitação foi recusada",
  "err.cause": "Causa: {cause}",
  "err.currentVersion": "Versão atual no servidor: {n}. Recarregue e reaplique sua alteração.",
  "err.stepNotRun": "não executado",
  "err.reload": "Recarregar",

  "config.adminOnly": "Apenas administradores alteram esta configuração; você pode consultá-la.",
  "config.version": "Versão",
  "config.globalScope": "global",
  "config.projectScope": "projeto",
  "secret.missing": "Não definida",
  "secret.active": "Armazenada",
  "secret.revoked": "Revogada",
  "state.draft": "Rascunho",
  "state.validated": "Validada",
  "state.active": "Ativa",
  "state.disabled": "Desativada",
  "state.auth_failed": "Falha de autenticação",
  "state.unverified": "Não verificado",
  "state.verified": "Verificado",
  "state.invalid": "Inválido",
  "state.running": "Em execução",
  "state.draining": "Drenando",
  "state.degraded": "Degradado",
  "state.stopped": "Parado",
  "state.crash_loop": "Reinícios em loop",
  "state.healthy": "Saudável",
  "state.unavailable": "Indisponível",
  "state.unknown": "Desconhecido",
  "origin.value.configured": "configurado",
  "origin.value.reported": "informado",
  "origin.value.estimated": "estimado",
  "origin.value.stale": "desatualizado",
  "origin.value.unknown": "desconhecido",
  "origin.value.global": "herdado (global)",
  "origin.value.project": "sobrescrito no projeto",
  "origin.value.task": "sobrescrito na tarefa",
  "origin.value.unset": "não definido",
  "adapter.omniroute": "OmniRoute",
  "adapter.openrouter": "OpenRouter (direto)",
  "adapter.nvidia_nim": "NVIDIA NIM (direto)",
  "adapter.jev": "Jev",
  "adapter.openai_responses": "OpenAI Responses",
  "adapter.openai_chat": "OpenAI Chat Completions",
  "adapter.integration_module": "Integração (módulo IA)",
  "authMode.bearer": "Token Bearer",
  "authMode.header": "Cabeçalho de chave de API",
  "authMode.none": "Sem autenticação",
  "cap.streaming": "Streaming",
  "cap.tool_calling": "Chamada de ferramentas",
  "cap.multi_turn_tools": "Ferramentas em vários turnos",
  "cap.json_schema": "JSON estrito",
  "cap.images": "Imagens",
  "cap.prompt_cache": "Cache de prompt",
  "cap.reasoning_summary": "Resumo de raciocínio",
  "cap.reasoning_effort": "Esforço de raciocínio",
  "capState.declared": "declarada",
  "capState.verified": "verificada",
  "capState.failed": "falhou",
  "capState.unknown": "desconhecida",
  "testStatus.passed": "Aprovado",
  "testStatus.failed": "Falhou",
  "testStatus.skipped": "Ignorado",
  "testStatus.unknown": "Desconhecido",
  "targetKind.chat": "Chat",
  "targetKind.embedding": "Embedding",
  "targetKind.rerank": "Rerank",
  "targetKind.decision": "Decisão",
  "agentRole.maestro": "Maestro",
  "agentRole.assistant": "Assistente",
  "agentRole.planner": "Planejador",
  "agentRole.classifier": "Classificador (Jev)",
  "agentRole.researcher": "Pesquisador",
  "agentRole.builder": "Construtor",
  "agentRole.tester": "Testador",
  "agentRole.critic": "Crítico",
  "agentRole.integrator": "Integrador",
  "agentRole.compactor": "Compactador",
  "agentRole.coach": "Treinador de agentes",
  "reviewer.maestro": "Maestro",
  "reviewer.critic": "Crítico",
  "reviewer.none": "Sem revisor",
  "errorClass.rate_limited": "limite de taxa",
  "errorClass.credit_exhausted": "crédito esgotado",
  "errorClass.unavailable": "indisponível",
  "errorClass.model_not_found": "modelo inexistente",
  "errorClass.context_exceeded": "contexto excedido",
  "trigger.capability_missing": "Capacidade ausente",
  "trigger.irreducible_context": "Contexto irredutível",
  "trigger.reproducible_quality_failure": "Falha de qualidade reproduzível",
  "trigger.risk_class": "Classe de risco",
  "trigger.material_stagnation": "Estagnação material",
  "window.day": "Dia",
  "window.week": "Semana",
  "window.month": "Mês",
  "gauntletMode.conventional": "Convencional (revisão única)",
  "gauntletMode.gauntlet": "Gauntlet (rodadas construtor ↔ crítico)",
  "gauntletReq.contract_change": "Mudanças de contrato",
  "gauntletReq.data_migration": "Migrações de dados",
  "gauntletReq.authentication": "Autenticação",
  "gauntletReq.high_risk": "Tarefas de alto risco",

  "tests.consumesTokens": "Este teste envia uma requisição real que consome tokens. Defina o máximo que aceita gastar nele.",
  "tests.maxCost": "Custo máximo deste teste (centavos)",
  "tests.maxCostHint": "Obrigatório. O teste é recusado acima deste orçamento.",
  "tests.maxCostRequired": "Informe um custo máximo maior que zero.",
  "tests.running": "Teste em execução…",
  "tests.failedToRun": "O teste não pôde ser executado",
  "tests.fixtureOnly": "Somente fixture — não homologado",
  "tests.fixtureOnlyHint": "O resultado veio de uma fixture de teste, não do provedor real. Não aprova o modelo para trabalho de produção.",
  "tests.kind": "Teste",
  "tests.result": "Resultado",
  "tests.latency": "Latência",
  "tests.usedTokens": "Usou tokens",
  "tests.when": "Quando",

  "settings.tab.routing": "Roteamento e Maestro",
  "providers.new": "Nova conexão",
  "providers.export": "Exportar (sem segredos)",
  "providers.exportHint": "A exportação leva apenas nomes, endpoints e referências; chaves nunca são exportadas e conexões importadas precisam ser revalidadas.",
  "providers.emptyTitle": "Nenhuma conexão de provedor ainda",
  "providers.emptyBody": "Adicione OmniRoute, OpenRouter direto, NVIDIA NIM direto ou o endpoint Jev aprovado. Nada vem pré-selecionado.",
  "providers.noPool": "Sem pool de cota compartilhado",
  "providers.baseUrl": "URL base de inferência",
  "providers.baseUrlHint": "A URL base da API (por exemplo …/v1), nunca o endereço de um painel.",
  "providers.authMode": "Autenticação",
  "providers.quotaPool": "Pool de cota",
  "providers.quotaPoolHint": "Conexões que usam a mesma conta compartilham um pool, para que a capacidade nunca seja contada duas vezes.",
  "providers.allowedKinds": "Tipos de modelo que esta conexão pode atender",
  "providers.allowedKindsHint": "Modelos de outros tipos não podem ser cadastrados nesta conexão e o roteamento nunca os envia para cá. Exemplo: limite o OpenRouter a Embedding e Rerank para que os modelos de chat venham do OmniRoute.",
  "providers.allowedKindsRequired": "Escolha pelo menos um tipo de modelo.",
  "providers.serves": "Atende",
  "providers.key": "Chave de API",
  "providers.noKeyNeeded": "Este modo de autenticação não usa chave",
  "providers.addKey": "Adicionar chave",
  "providers.replaceKey": "Substituir chave",
  "providers.revokeKey": "Revogar chave",
  "providers.enable": "Voltar para rascunho",
  "providers.disable": "Desativar",
  "providers.saved": "Conexão salva.",
  "providers.tests": "Testes",
  "providers.testsHint": "Testes de conexão e catálogo não usam tokens; a inferência mínima usa. Um item do catálogo não prova permissão nem capacidade.",
  "providers.testConnection": "Testar conexão",
  "providers.discoverCatalog": "Descobrir catálogo",
  "providers.testInference": "Testar inferência mínima",
  "providers.inferenceTarget": "Modelo a testar",
  "providers.chooseTarget": "Escolha um modelo…",
  "providers.noTargets": "Cadastre primeiro um modelo para esta conexão (Modelos e combos).",
  "providers.runInference": "Executar teste de inferência",
  "providers.catalogUnavailable": "Catálogo indisponível",
  "providers.catalogUnavailableBody": "Esta conexão não oferece catálogo. Cadastre os IDs exatos manualmente.",
  "providers.catalogNote": "Itens do catálogo não provam permissão nem capacidade; cadastre IDs exatos e teste-os.",
  "providers.catalogEmpty": "O catálogo não retornou modelos.",
  "providers.notRegistered": "não cadastrado",
  "providers.recentTests": "Testes recentes",
  "providers.noTests": "Nenhum teste registrado ainda.",
  "providers.editTitle": "Editar “{name}”",
  "providers.dialogBody": "As alterações usam versões otimistas: se alguém salvou nesse meio-tempo, será pedido que você recarregue.",
  "providers.name": "Nome",
  "providers.adapter": "Adaptador",
  "providers.editNote": "Alterar o endpoint ou a autenticação exige testar novamente antes do uso.",
  "providers.keyAfterCreate": "Adicione a chave depois de criar a conexão; ela é armazenada somente para escrita.",
  "providers.addKeyTitle": "Adicionar chave — {name}",
  "providers.replaceKeyTitle": "Substituir chave — {name}",
  "providers.keyDialogBody": "A chave é enviada uma vez, guardada no cofre e nunca mais exibida. Só o estado e um identificador mascarado aparecem.",
  "providers.currentKey": "Chave atual:",
  "providers.apiKey": "Chave de API",
  "providers.keyRetestHint": "Uma nova chave devolve a conexão ao rascunho até um teste passar.",
  "providers.storeKey": "Guardar chave",
  "providers.keyStored": "Chave guardada. Teste a conexão antes de usá-la.",
  "providers.revokeTitle": "Revogar a chave de “{name}”?",
  "providers.revokeBody": "A revogação vale imediatamente: novos testes e chamadas são recusados. Reverter uma configuração nunca restaura uma chave revogada.",
  "providers.keyRevoked": "Chave revogada.",
  "providers.moduleInstance": "Conta do módulo IA",
  "providers.moduleInstanceHint": "Contas ativas de provedores de IA em Configurações → Integrações. A chave fica na conta; esta conexão guarda roteamento, orçamento e cota.",
  "providers.chooseModuleInstance": "Escolha uma conta…",
  "providers.noModuleInstances": "Nenhuma conta ativa de provedor de IA ainda. Conecte e ative uma em Configurações → Integrações.",
  "providers.moduleKey": "Guardada na conta do módulo (Integrações)",
  "providers.moduleInstanceUnavailable": "Conta indisponível",

  "models.new": "Novo modelo",
  "models.needConnection": "Crie primeiro uma conexão de provedor.",
  "models.exactIdHint": "IDs externos são usados exatamente como digitados — nunca mapeados por semelhança nem deduzidos de um nome comercial.",
  "models.emptyTitle": "Nenhum modelo cadastrado",
  "models.emptyBody": "Cadastre IDs exatos de modelos ou combos por conexão. IDs manuais ficam não verificados até um teste de inferência passar.",
  "models.renamedTitle": "Renomeado “{from}” → “{to}”",
  "models.renamedBody": "O ID interno, os vínculos e o histórico foram mantidos. A verificação foi zerada; teste de novo antes de ativar. Configuração afetada:",
  "models.noDependents": "Nenhum perfil de agente ou configuração de roteamento usa este modelo.",
  "models.dependentProfile": "Perfil de agente “{name}” ({role})",
  "models.dependentConfig": "Configuração de roteamento v{version} ({state}, {scope})",
  "models.strong": "Forte",
  "models.externalId": "ID externo do modelo",
  "models.connection": "Conexão",
  "models.kindProtocol": "Tipo · protocolo",
  "models.contextOutput": "Contexto / saída máxima",
  "models.unknownValue": "desconhecido",
  "models.free": "Gratuito",
  "models.freeUnknown": "Desconhecido (nunca presumido gratuito)",
  "models.freeYes": "Sim",
  "models.freeNo": "Não",
  "models.freeHint": "Desconhecido continua desconhecido; nunca é tratado como gratuito.",
  "models.pricing": "Preço",
  "models.pricingValue": "{currency} {input} entrada / {output} saída por milhão de tokens · válido desde {from} · {source}",
  "models.pricingUnknown": "Desconhecido",
  "models.verifiedAt": "Verificado",
  "models.neverVerified": "Nunca verificado",
  "models.capabilities": "Capacidades",
  "models.capabilitiesLegend": "Capacidades: declaradas (não comprovadas) vs verificadas por teste",
  "models.noCapabilities": "Nenhuma capacidade declarada ou verificada.",
  "models.probeCapabilities": "Testar capacidades",
  "models.conformance": "Conformidade do backend",
  "models.runProbe": "Executar teste",
  "models.historyAndDependents": "Histórico, testes e dependentes",
  "models.dependents": "Usado por",
  "models.versions": "Versões",
  "models.probes": "Testes",
  "models.noProbes": "Nenhum teste registrado ainda.",
  "models.returnedModel": "retornou {model}",
  "models.editTitle": "Editar “{name}”",
  "models.dialogBody": "Informe o ID externo exato. Valores desconhecidos continuam desconhecidos; limites conservadores valem até serem conhecidos.",
  "models.renameHint": "Alterar o ID externo mantém o ID interno e o histórico, zera a verificação e lista a configuração afetada.",
  "models.externalIdHint": "ID exato ou alias como o provedor espera.",
  "models.displayName": "Nome de exibição",
  "models.alias": "Alias interno",
  "models.aliasHint": "Nome interno estável, como free-coder-primary (minúsculas, dígitos e hífens).",
  "models.kind": "Tipo",
  "models.kindNotAllowedOption": "{kind} — não atendido por esta conexão",
  "models.kindRestricted": "Esta conexão atende apenas: {kinds}. Altere em Configurações → Provedores e chaves.",
  "models.kindNotServed": "Este tipo não é atendido pela conexão (ela atende apenas: {kinds}). O roteamento trata este modelo como indisponível; escolha um tipo atendido.",
  "models.protocol": "Protocolo",
  "models.contextWindow": "Janela de contexto (tokens, declarada)",
  "models.maxOutput": "Saída máxima (tokens, declarada)",
  "models.unknownAllowed": "Deixe em branco se desconhecido.",
  "models.declaredSource": "Fonte: informado pelo operador neste formulário, não verificado por teste. Deixe em branco se desconhecido.",
  "models.declaredTag": "declarado · fonte: informado pelo operador",
  "models.declaredCapabilities": "Capacidades declaradas",
  "models.declaredHint": "Uma declaração não é prova; só testes aprovados marcam uma capacidade como verificada.",
  "models.strongFlag": "Modelo forte (somente administradores)",
  "models.strongHint": "Só modelos fortes podem atuar como Maestro ou substituto do Maestro. É uma decisão explícita do administrador, nunca deduzida do nome do modelo.",
  "models.pricingKnown": "O preço é conhecido",
  "models.currency": "Moeda (ISO)",
  "models.inputPerMtok": "Entrada por milhão de tokens",
  "models.outputPerMtok": "Saída por milhão de tokens",
  "models.validFrom": "Válido desde",
  "models.priceSource": "Fonte",
  "models.editResetsVerification": "Alterar o ID externo zera a verificação até um novo teste passar.",
  "models.invalidNumber": "Confira os campos numéricos.",
  "models.pricingIncomplete": "O preço precisa de moeda com 3 letras, data de validade e fonte.",
  "models.saved": "Modelo salvo.",

  "agents.modelVsExecutor": "Modelo não é executor: trocá-lo não instala CLI, não concede ferramentas nem cria runner. “Sem modelo” indica um executor determinístico.",
  "agents.matrix": "Perfis de agente por papel",
  "agents.role": "Papel",
  "agents.profiles": "Perfis de agente",
  "agents.maestroMandatory": "Obrigatório para aceite de entregas.",
  "agents.noProfiles": "Nenhum perfil para este papel.",
  "agents.model": "Modelo principal",
  "agents.noModel": "Sem modelo (executor determinístico)",
  "agents.fallbacks": "Alternativas",
  "agents.reviewer": "Revisor",
  "agents.tools": "Ferramentas",
  "agents.concurrency": "Concorrência",
  "agents.editProfile": "Editar {name}",
  "agents.add": "Adicionar perfil",
  "agents.addFor": "Adicionar perfil de {role}",
  "agents.appliesToNew": "As alterações valem só para novas tentativas; tentativas em execução mantêm a rota fixada.",
  "agents.newTitle": "Novo perfil de {role}",
  "agents.dialogBody": "Pode haver vários perfis do mesmo papel com modelos diferentes; o roteamento decide qual assume cada tarefa.",
  "agents.name": "Nome",
  "agents.chooseModel": "Escolha um modelo…",
  "agents.modelHint": "Modelos não verificados podem ser escolhidos, mas a validação do roteamento os lista como impedimento.",
  "agents.toolsHint": "Nomes de ferramentas permitidas, separados por vírgula.",
  "agents.contextLimit": "Limite de contexto (tokens)",
  "agents.outputLimit": "Limite de saída (tokens)",
  "agents.maxCostPerAttempt": "Custo máximo por tentativa (centavos)",
  "agents.maxCalls": "Máximo de chamadas por tentativa",
  "agents.fallbacksHint": "Lista ordenada; a alternativa é escolhida antes de uma tentativa ou após um checkpoint, nunca no meio de um stream.",
  "agents.moveUp": "Subir alternativa {n}",
  "agents.moveDown": "Descer alternativa {n}",
  "agents.addFallback": "Adicionar alternativa",
  "agents.instructions": "Instruções",
  "agents.disableProfile": "Desativar este perfil",
  "agents.nameAndModelRequired": "Dê um nome ao perfil e escolha um modelo (ou “sem modelo”).",
  "agents.saved": "Perfil de agente salvo.",

  "quotas.new": "Novo pool de cota",
  "quotas.dataAsOf": "Dados de {time}",
  "quotas.emptyTitle": "Nenhum pool de cota ainda",
  "quotas.emptyBody": "Crie um pool por conta de provedor e vincule as conexões e modelos que o compartilham.",
  "quotas.confidence": "confiança {pct}%",
  "quotas.usedOf": "{used} de {limit} requisições na janela atual",
  "quotas.conservative": "limite conservador aplicado",
  "quotas.noRpmLimit": "{used} requisições na janela atual · limite de RPM desconhecido",
  "quotas.rpm": "Requisições por minuto",
  "quotas.effective": "efetivo {n}",
  "quotas.tpm": "Tokens por minuto",
  "quotas.concurrency": "Concorrência",
  "quotas.budget": "Teto de gasto",
  "quotas.reserved": "Reservadas",
  "quotas.inFlight": "Em andamento",
  "quotas.waiting": "Tarefas aguardando",
  "quotas.resetIn": "A janela renova em",
  "quotas.resetUnknown": "desconhecido",
  "quotas.nextSlot": "Próxima vaga em",
  "quotas.reported": "O provedor informou {requests} requisições e {tokens} tokens restantes ({when})",
  "quotas.noReport": "Nenhuma cota informada pelo provedor; saldo ausente é desconhecido, não zero.",
  "quotas.sharedBy": "Compartilhado por",
  "quotas.noLinks": "Nenhuma conexão ou modelo usa este pool ainda.",
  "quotas.sharedNote": "{n} conexões (gateway e direta) compartilham este pool: um único limite, nunca dobrado.",
  "quotas.editTitle": "Editar pool “{name}”",
  "quotas.dialogBody": "Os limites valem para todas as conexões e modelos vinculados ao pool.",
  "quotas.name": "Nome",
  "quotas.emptyIsUnknown": "Deixe em branco se desconhecido.",
  "quotas.budgetCents": "Teto de gasto (centavos)",
  "quotas.safetyMargin": "Margem de segurança",
  "quotas.safetyMarginHint": "Fração do limite mantida livre (0 – 0,5).",
  "quotas.origin": "Origem do limite",
  "quotas.originHint": "Distingue limite local, cota informada, estimativa e valor desatualizado.",
  "quotas.saved": "Pool de cota salvo.",

  "routing.intro": "Rascunhos são validados contra os provedores, modelos e perfis atuais; só um rascunho sem impedimentos pode ser ativado. A ativação afeta apenas novas tentativas.",
  "routing.newDraft": "Novo rascunho",
  "routing.newDraftFromActive": "Novo rascunho a partir da v{n} ativa",
  "routing.draftSaved": "Rascunho v{n} salvo e validado.",
  "routing.currentAndDrafts": "Configuração ativa e rascunhos pendentes",
  "routing.noConfigs": "Nenhuma configuração de roteamento ainda.",
  "routing.historyHint": "Todas as versões, com diferenças e reversão, estão em",
  "routing.roles": "Papéis",
  "routing.rolesHint": "Escolha o perfil de agente padrão por papel. Papéis não configurados aparecem como impedimento quando obrigatórios.",
  "routing.defaultAgent": "Agente padrão",
  "routing.defaultAgentFor": "Agente padrão de {role}",
  "routing.fallbacksAndCaps": "Capacidades exigidas e alternativas",
  "routing.notConfigured": "Não configurado",
  "routing.allowedAgents": "Outros agentes que podem assumir tarefas",
  "routing.routeSummary": "{caps} capacidades exigidas · {fallbacks} alternativas",
  "routing.requiredCaps": "Capacidades exigidas",
  "routing.addFallbackFor": "Modelo alternativo para {role}",
  "routing.fallbackOn": "Usar em caso de",
  "routing.addFallback": "Adicionar alternativa",
  "routing.maestro": "Maestro",
  "routing.maestroHint": "O Maestro aceita entregas e não pode ser desativado. Só modelos marcados como fortes por um administrador podem atuar como Maestro ou substituto.",
  "routing.maestroPrimary": "Maestro principal",
  "routing.maestroNone": "Não selecionado",
  "routing.notStrong": "não é forte",
  "routing.noStrongTargets": "Nenhum modelo está marcado como forte ainda (Modelos e combos).",
  "routing.substitutes": "Substitutos fortes",
  "routing.substitutesList": "substitutos: {list}",
  "routing.freeFirst": "Gratuito primeiro",
  "routing.freeFirstHint": "Rotas pagas ou fortes de implementação só são usadas após um destes gatilhos versionados.",
  "routing.freeFirstEnabled": "Preferir rotas gratuitas",
  "routing.escalationTriggers": "Gatilhos de escalonamento",
  "routing.budgets": "Orçamentos",
  "routing.softLimit": "Limite de alerta (centavos)",
  "routing.hardLimit": "Limite rígido (centavos)",
  "routing.window": "Janela do orçamento",
  "routing.gauntlet": "Gauntlet Loop",
  "routing.gauntletHint": "Construtor e crítico se alternam até cumprir o contrato de avaliação, atingir o limite de rodadas ou estagnar.",
  "routing.gauntletMode": "Modo",
  "routing.maxRounds": "Máximo de rodadas",
  "routing.stagnationRounds": "Estagnação após rodadas sem progresso",
  "routing.stagnationHint": "Rodadas sem progresso material antes de o loop parar e escalar.",
  "routing.gauntletRequiredFor": "Obrigatório para",
  "routing.saveDraft": "Salvar rascunho e validar",
  "routing.saveDraftHint": "Salvar cria uma nova versão de rascunho; nada é ativado.",
  "routing.notValidated": "Ainda não validada",
  "routing.valid": "Sem impedimentos",
  "routing.impedimentCount": "{n} impedimentos",
  "routing.versionN": "Versão {n}",
  "routing.activatedAt": "ativada {when}",
  "routing.author": "por {who}",
  "routing.validate": "Validar",
  "routing.activate": "Ativar",
  "routing.rollbackTo": "Reverter para v{n}",
  "routing.activated": "A versão {n} está ativa.",
  "routing.noChanges": "Sem mudanças desde a v{n}.",
  "routing.changedSince": "Mudou desde a v{n}: {list}",
  "routing.firstVersion": "Primeira versão.",

  "effective.title": "Configuração efetiva por projeto",
  "effective.intro": "Resolvida global → projeto com a origem de cada valor: agente → papel → modelo/API → ferramentas → pool de cota → alternativa → revisor/Maestro.",
  "effective.chooseProject": "Projeto",
  "effective.pickProject": "Escolha um projeto…",
  "effective.openProjectOverrides": "Abrir as sobrescritas deste projeto",
  "effective.ready": "Pronto para executar",
  "effective.notReady": "Não está pronto",
  "effective.versions": "Global v{global} · projeto v{project}",
  "effective.caption": "Configuração efetiva: agente, papel, modelo e API, ferramentas, pool de cota, alternativas, revisor e origem",
  "effective.agent": "Agente",
  "effective.modelApi": "Modelo / API",
  "effective.origin": "Origem",
  "effective.toolsDeclared": "Declaradas, não aplicadas pelo motor: {list}",

  "history.rollbackNote": "Reverter ativa de novo uma versão anterior após revalidá-la; nunca restaura uma chave revogada.",
  "gauntlet.activeFrom": "Valores da configuração global ativa (v{n}).",
  "gauntlet.noActive": "Nenhuma configuração global está ativa; os padrões valem quando uma for ativada.",
  "gauntlet.builderCritic": "Construtor e crítico vêm dos perfis de agente desses papéis; o resultado das rodadas aparece na árvore de trabalho de cada tarefa.",
  "gauntlet.editInRouting": "Editar em Roteamento e Maestro",

  "infra.adminOnlyTitle": "A infraestrutura é gerida por administradores",
  "infra.adminOnlyBody": "Servidores, credenciais SSH e conexões Coolify são visíveis apenas para administradores.",
  "infra.blockedNote": "Cadastro e política já são gravados. As etapas de rede SSH e Coolify não estão habilitadas nesta versão: os testes retornam “bloqueado” e nada é tentado no servidor.",
  "infra.servers": "Servidores cadastrados",
  "infra.noServers": "Nenhum servidor cadastrado ainda.",
  "infra.purpose.development": "Desenvolvimento",
  "infra.purpose.testing": "Testes",
  "infra.address": "Endereço",
  "infra.expectedFingerprint": "Fingerprint esperado da chave do host",
  "infra.notDeclared": "Não declarado",
  "infra.policy": "O que o preset de autonomia permite neste servidor",
  "infra.policyBound": "Vale só para este servidor; outros servidores, produção, contas de nuvem e cobrança nunca herdam a permissão.",
  "infra.grants": "Permitido",
  "infra.excluded": "Nunca permitido",
  "infra.disable": "Desativar servidor",
  "infra.resultTitle": "Resultado de “{action}”",
  "infra.unexpectedSuccess": "O servidor aceitou a solicitação.",
  "infra.noWebLogin": "Nenhum login web configurado.",
  "infra.coolifyCapabilitiesUnknown": "Capacidades desconhecidas até a integração ser habilitada.",
  "infra.registerServer": "Cadastrar um servidor",
  "infra.declaredOs": "Sistema declarado",
  "infra.declaredArch": "Arquitetura declarada",
  "infra.fingerprintHint": "Formato OpenSSH SHA256. Uma chave diferente na primeira validação bloqueia a conexão para revisão de identidade.",
  "infra.observedHint": "Registrado pela primeira validação real.",
  "infra.operation": "Workspace e autonomia",
  "infra.presetHint": "Vale só para este servidor e pode ser revogado desativando o servidor.",
  "infra.saveServer": "Cadastrar servidor",
  "infra.saveServerHint": "Os segredos são enviados uma vez e guardados no cofre; o formulário é limpo após salvar.",
  "infra.serverSaved": "Servidor cadastrado. Os segredos foram guardados; só o estado deles é exibido.",
  "infra.rootElevation": "O usuário root usa o modo de elevação root.",
  "infra.fingerprintFormat": "Use o formato OpenSSH SHA256:<base64>.",
  "infra.absolutePath": "Use um caminho absoluto (começando com /).",
  "infra.portRange": "Use uma porta entre 1 e 65535.",
  "infra.registerCoolify": "Cadastrar uma conexão Coolify",
  "infra.server": "Servidor",
  "infra.chooseServer": "Escolha um servidor…",
  "infra.registerServerFirst": "Cadastre primeiro um servidor.",
  "infra.saveCoolify": "Cadastrar conexão Coolify",
  "infra.coolifySaved": "Conexão Coolify cadastrada.",
  "infra.coolifyRequired": "Escolha um servidor e informe a URL base do Coolify.",
  "infra.webUserRequired": "Uma senha web exige o usuário web.",
  "infra.disableTitle": "Desativar “{name}”?",
  "infra.disableBody": "Desativar revoga imediatamente a autorização do servidor para novas ações. Ele pode ser cadastrado de novo depois.",
  "infra.disabled": "Servidor desativado.",
  "elevation.root": "Root",
  "elevation.sudo_nopasswd": "Sudo sem senha",
  "elevation.sudo_password": "Sudo com senha separada",

  "project.drain": "Drenar",
  "project.stop": "Parar",
  "project.startHint": "Inicia as tarefas prontas dentro da política.",
  "project.pauseHint": "Pausa o trabalho em execução no próximo ponto seguro.",
  "project.resumeHint": "Continua o trabalho pausado ou em drenagem.",
  "project.drainHint": "Conclui as tentativas em execução e não inicia nada novo.",
  "project.stopHint": "Cancela as execuções em andamento; o histórico é mantido.",
  "project.drainConfirmTitle": "Drenar este projeto?",
  "project.stopConfirmTitle": "Parar este projeto?",
  "project.execution.drainRequested": "Drenagem solicitada.",
  "project.execution.stopRequested": "Parada solicitada.",
  "project.moreExecution": "Mais",
  "project.validateNow": "Validar agora",
  "project.validateAgain": "Validar novamente",
  "project.validating": "Validando…",
  "project.starting": "Iniciando…",
  "project.startBlockedToast": "Não foi possível iniciar: {n} itens para corrigir",
  "project.startNotPossible": "Não foi possível iniciar: a verificação de prontidão não terminou.",
  "project.validateStillRunning": "A verificação de prontidão ainda está em andamento; tente novamente em instantes.",
  "project.validateDone": "Verificação de prontidão concluída.",
  "project.validateFailed": "A verificação de prontidão não terminou: {message}",
  "project.readinessBadge.ready": "Pronto",
  "project.readinessBadge.readyChecked": "Pronto · verificado {when}",
  "project.readinessBadge.notReadyChecked": "Não pronto · {n} impedimentos · verificado {when}",
  "project.readinessBadge.notReadyChecked.one": "Não pronto · 1 impedimento · verificado {when}",
  "project.readinessBadge.notReadyNever": "Não pronto · {n} impedimentos · nunca verificado",
  "project.readinessBadge.notReadyNever.one": "Não pronto · 1 impedimento · nunca verificado",
  "project.readinessBadge.openAssistant": "{status} — abrir o assistente",
  "readiness.status.passed": "Aprovado",
  "readiness.status.failed": "Reprovado",
  "readiness.status.unknown": "Desconhecido",
  "readiness.status.not_applicable": "Não se aplica",
  "readiness.check.repository": "Repositório",
  "readiness.check.base_branch": "Branch base",
  "readiness.check.workspace_authorized": "Workspace autorizado",
  "readiness.check.runner_healthy": "Runner saudável",
  "readiness.check.executor_available": "Executor disponível",
  "readiness.check.test_command": "Comando de teste",
  "readiness.check.eligible_route": "Rota de modelo elegível",
  "project.engineErrors": "O estado mudou, mas o motor de execução relatou erros",

  "projectRouting.title": "Roteamento deste projeto",
  "projectRouting.intro": "Os valores são herdados da configuração global, a menos que este projeto os sobrescreva. Sobrescritas não ampliam permissões nem limites.",
  "projectRouting.editOverride": "Editar sobrescritas",
  "projectRouting.restoreInheritance": "Restaurar herança",
  "projectRouting.overrideTitle": "Sobrescritas do projeto (rascunho)",
  "projectRouting.overrideHint": "“Herdar” mantém o valor global. Salvar cria um rascunho e mostra a validação do servidor antes de qualquer ativação.",
  "projectRouting.inherit": "Herdar do global",
  "projectRouting.hardLimitHint": "Deixe em branco para herdar. Um projeto não pode elevar o teto global.",
  "projectRouting.preview": "Salvar rascunho e pré-visualizar",
  "projectRouting.previewTitle": "Pré-visualização do rascunho v{n}",
  "projectRouting.previewNote": "O servidor validou este rascunho e resolveu a tabela como se estivesse ativo (pré-visualização somente leitura). Nada muda até você ativá-lo.",
  "projectRouting.changes": "Mudanças propostas pelo rascunho",
  "projectRouting.current": "Atual (efetivo)",
  "projectRouting.proposed": "Após a ativação",
  "projectRouting.inheritedFromGlobal": "Herdado do global",
  "projectRouting.noRoleChanges": "O rascunho não altera nenhuma atribuição de papel.",
  "projectRouting.activate": "Ativar rascunho",
  "projectRouting.fixImpediments": "Resolva os impedimentos antes de ativar.",
  "projectRouting.versions": "Versões do projeto ({n})",
  "projectRouting.noVersions": "Este projeto ainda não tem sobrescritas.",
  "maestro.title": "Maestro deste projeto",
  "maestro.primary": "Maestro",
  "maestro.epoch": "Época de supervisão",
  "maestro.noActiveGoal": "Nenhum objetivo ativo",
  "maestro.readiness": "Prontidão",
  "maestro.lastReview": "Última revisão",
  "maestro.override": "Sobrescrever Maestro",
  "maestro.overrideHint": "Trocar o Maestro abre uma nova época de supervisão; aprovações passadas não são reinterpretadas.",
  "maestro.apply": "Aplicar Maestro",
  "maestro.saved": "Maestro atualizado.",
  "maestro.newEpoch": "Nova época de supervisão: {list}",

  "overview.attemptsTree": "Tentativas e etapas",
  "overview.usageUnavailable": "Não foi possível ler o uso",
  "trace.loadFailed": "Não foi possível carregar a árvore de trabalho",
  "trace.noAttempts": "Nenhuma tentativa registrada ainda.",
  "trace.attempts": "Tentativas",
  "trace.attemptN": "Tentativa {n}",
  "trace.agent": "agente {name}",
  "trace.effectiveModel": "modelo {model}",
  "trace.pinnedModel": "fixado {model} (efetivo não informado)",
  "trace.modelNotReported": "modelo não informado",
  "trace.rerunOf": "Reexecução da tentativa {n}",
  "trace.fixedBy": "Corrigida pela tentativa {n}",
  "trace.divergence": "Pedido {requested}, o provedor respondeu com {effective}",
  "trace.usageLoading": "Carregando uso…",
  "trace.noCalls": "Nenhuma chamada de modelo registrada",
  "trace.running": "em andamento",
  "trace.duration": "duração {value}",
  "trace.elapsed": "decorrido {value}",
  "trace.role": "papel {role}",
  "trace.otherSteps": "Etapas fora de tentativas",
  "trace.gauntletRound": "Rodada {n} de {max} do Gauntlet",
  "trace.gauntletCost": "custo {value}",
  "trace.gauntletCostPartial": "custo conhecido {value} · {n} rodadas com custo desconhecido",
  "trace.roundN": "Rodada {n}",
  "trace.builderCritic": "tentativa do construtor {builder} · tentativa do crítico {critic}",
  "trace.resolvedCriteria": "{n} critérios resolvidos",
  "trace.mainFinding": "Principal achado: {text}",
  "trace.maestroReviews": "Revisões do Maestro",
  "trace.epoch": "época {n}",
  "trace.generatedAt": "Rastro de {time}",
  "trace.orphans": "{n} spans sem pai conhecido",
  "usage.inputTokens": "Entrada {value} tokens",
  "usage.outputTokens": "Saída {value} tokens",
  "usage.unknown": "desconhecido",
  "usage.partial": "{n} (conhecido em {k} de {total} chamadas)",
  "usage.costTotal": "Custo {value}",
  "usage.costPartial": "Custo conhecido {value} · total desconhecido ({n} chamadas sem custo)",
  "usage.costUnknown": "Custo desconhecido ({n} chamadas sem custo)",
  "usage.costUnknownShort": "custo desconhecido",
  "usage.estimatedPart": "{value} estimado",

  "chat.scope": "Respostas a partir dos dados deste projeto",
  "chat.log": "Conversa",
  "chat.empty": "Pergunte sobre status, custo, pendências ou bloqueios, ou crie uma tarefa. As respostas vêm dos dados do projeto, com links.",
  "chat.modes": "Tipo de mensagem",
  "chat.mode.ask": "Perguntar",
  "chat.mode.task": "Nova tarefa",
  "chat.mode.guidance": "Orientação",
  "chat.requestLabel": "Descreva a nova demanda",
  "chat.requestPlaceholder": "Descreva a demanda; o texto é guardado literalmente…",
  "chat.taskTitle": "Título da tarefa",
  "chat.criteria": "Critérios de aceite",
  "chat.criteriaHint": "Um por linha.",
  "chat.guidanceTask": "Tarefa",
  "chat.guidanceHint": "A orientação gera um evento para a tarefa; nunca altera em silêncio os critérios de uma tentativa em execução.",
  "chat.chooseTask": "Escolha uma tarefa…",
  "chat.taskRequired": "Descreva a demanda (a primeira linha vira o título quando nenhum for informado).",
  "chat.guidanceRequired": "Escolha uma tarefa e escreva a orientação.",
  "chat.commandHint": "Os comandos seguem as mesmas permissões e políticas do painel; enviar duas vezes nunca duplica.",
  "chat.stop": "Parar de aguardar a resposta",
  "chat.stopHint": "Parar apenas deixa de aguardar esta resposta; nunca cancela tarefas.",
  "chat.historyUnavailable": "Não foi possível carregar as mensagens anteriores; uma nova conversa será iniciada.",
  "chat.kind.requested": "Ação solicitada",
  "chat.kind.inProgress": "Ação em andamento",
  "chat.kind.proven": "Resultado confirmado pelo servidor",
  "chat.kind.answer": "Resposta com dados do projeto",
  "chat.kind.explanation": "Explicação",
  "chat.thinking": "Lendo os dados do projeto…",
  "chat.cancelled": "Resposta cancelada. As tarefas não são afetadas.",
  "chat.cancelledCommand": "Se o comando já chegou ao servidor, pode ter sido aplicado. Conferir reutiliza a mesma chave de requisição, então nada é duplicado.",
  "chat.checkOutcome": "Conferir o resultado",
  "chat.failed": "A mensagem não foi processada",
  "chat.fromHistory": "mensagem anterior (os links não são guardados)",
  "chat.refs": "Itens relacionados",
  "chat.signalSent": "A tarefa em execução foi notificada.",
  "chat.signalUnavailable": "Orientação registrada; o motor está indisponível, então ela será lida na próxima tentativa.",
  "chat.dataAsOf": "Dados de {time} (evento {cursor})",
  "chat.source": "fonte: {source}",
  "chat.cmd.createTask": "Criar tarefa “{title}”",
  "chat.cmd.guidance": "Adicionar orientação a uma tarefa",
  "chat.cmd.importPrd": "Importar PRD “{title}”",
  "chatRef.task": "Tarefa",
  "chatRef.board": "Kanban",
  "chatRef.project": "Projeto",
  "chatRef.usage": "Uso e execuções",
  "chatRef.versions": "Versões",
  "chatRef.prds": "PRDs",
  "chatRef.prd_version": "Versão do PRD",
  "home.conversations": "Conversas",
  "home.newChat": "Nova conversa",
  "home.noConversations": "Suas conversas aparecerão aqui.",
  "home.moreConversations": "Conversas anteriores",
  "home.latestConversations": "Conversas recentes",
  "home.chatTitle": "Sobre o que você quer conversar?",
  "home.mode": "O que você quer fazer?",
  "home.mode.build": "Desenvolver",
  "home.mode.ask": "Chat",
  "home.askFallbackTitle": "Conversa",
  "home.askPrivate": "Privado para você: outros membros nunca veem esta conversa. As respostas vêm dos projetos a que você tem acesso.",

  "runs.attempts": "Tentativas",
  "runs.project": "Projeto",
  "runs.task": "Tarefa",
  "runs.attempt": "Tentativa",
  "runs.state": "Estado",
  "runs.started": "Início",
  "runs.duration": "Duração",
  "runs.noAttempts": "Nenhuma tentativa ainda",
  "runs.traceFailed": "Rastro indisponível",
  "runs.showTree": "Mostrar árvore",
  "runs.hideTree": "Ocultar árvore",
  "runs.emptyTitle": "Nenhuma execução ainda",
  "runs.emptyBody": "As tentativas aparecem quando as tarefas saem do backlog e o motor de execução as executa.",
  "runs.noProjectsTitle": "Nenhum projeto ainda",
  "runs.noProjectsBody": "Crie um projeto para ver as execuções dele aqui.",

  "obs.health": "Saúde dos componentes",
  "obs.noComponents": "A API não informou componentes.",
  "obs.component": "Componente",
  "obs.state": "Estado",
  "obs.detail": "Detalhe",
  "obs.checkedAt": "Verificado",
  "obs.runtime": "Serviços de runtime",
  "reports.title": "Relatórios",
  "reports.bottlenecks": "Gargalos: últimos 15 dias × os 15 dias anteriores",
  "reports.groupBy": "Agrupar por",
  "reports.group.step": "Etapa",
  "reports.group.model": "Modelo",
  "reports.group.role": "Papel",
  "reports.group": "Grupo",
  "reports.before": "Antes",
  "reports.after": "Depois",
  "reports.delta": "Variação do p50",
  "reports.notComparable": "amostra insuficiente",
  "reports.qualityCost": "{succeeded}/{attempts} tentativas com sucesso ({success}) · testes aprovados {passed}/{gates} ({passRate}) · custo conhecido {cost}, {unknown} chamada(s) sem custo conhecido",
  "reports.noSpans": "Ainda não há etapas medidas nessas janelas.",
  "reports.sameConditions": "As duas janelas usaram os mesmos modelos e tipos de tarefa.",
  "reports.differentConditions": "As janelas diferem em modelos ou tipos de tarefa: compare com cuidado.",
  "reports.reviewModes": "Revisão convencional × Gauntlet (últimos 30 dias)",
  "reports.taskClass": "Classe da tarefa",
  "reports.mode": "Modo",
  "reports.tasks": "Aceitas / tarefas",
  "reports.firstRound": "Aceite na 1ª rodada",
  "reports.rounds": "Rodadas (média)",
  "reports.rework": "Retrabalho",
  "reports.costPerAccepted": "Custo por aceita",
  "reports.costUnknown": "desconhecido",
  "reports.conventional": "Convencional",
  "reports.noReviews": "Ainda não há tarefa revisada nesta janela.",
  "obs.retention": "Retenção",
  "obs.retentionDetailed": "Logs detalhados são mantidos por {n} dias.",
  "obs.retentionEnforcement": "O expurgo roda no worker só depois que o operador liga; logs apagados só voltam por backup. Uso, spans e trilha de auditoria nunca são expurgados.",
  "obs.retentionNotEnforced": "{what}: {n} dias (ainda não aplicado)",
  "obs.retentionChange": "Alterar a retenção dos logs detalhados",
  "obs.retentionDaysLabel": "Dias de logs detalhados",
  "obs.retentionDaysRange": "Informe um número inteiro de dias entre 1 e 3650.",
  "obs.retentionRun": "{when}: {n} linhas de log anteriores a {cutoff} removidas",
  "obs.retentionNoRuns": "Nenhum expurgo rodou ainda.",
  "obs.retentionNoteTitle": "Detalhe antigo expirado",
  "obs.alerts": "Alertas",
  "obs.alertsShowRecovered": "Mostrar recuperados",
  "obs.alertsNone": "Nenhum alerta ativo: os workers estão respondendo e a telemetria está em dia.",
  "obs.alertsNoneRecovered": "Nenhum alerta recuperado ainda.",
  "obs.alertSeverity": "Severidade",
  "obs.alertRule": "Alerta",
  "obs.alertCause": "Causa",
  "obs.alertOpened": "Aberto",
  "obs.alertPlatform": "plataforma",
  "obs.alertOrganization": "organização",
  "obs.alertOccurrences": "{n} ocorrências",
  "obs.alertRecoveredAt": "recuperado {when}",
  "obs.alertAcknowledge": "Reconhecer",
  "obs.healthCol": "Saúde",
  "alertRule.runner_heartbeat_lost": "Worker parou de responder",
  "alertRule.runner_crash_loop": "Worker em loop de falhas",
  "alertRule.telemetry_delayed": "Telemetria atrasada",
  "alertState.open": "Aberto",
  "alertState.acknowledged": "Reconhecido",
  "alertState.recovered": "Recuperado",
  "severity.critical": "Crítica",
  "severity.high": "Alta",
  "severity.medium": "Média",
  "severity.low": "Baixa",
  "severity.info": "Informativa",
  "obs.noServices": "Nenhum serviço de runtime se registrou ainda.",
  "obs.service": "Serviço",
  "obs.heartbeat": "Último heartbeat",
  "obs.noHeartbeat": "nunca",
  "obs.stale": "desatualizado",
  "obs.version": "Versão",
  "obs.rowVersion": "Versão do registro",
  "obs.restarts": "Reinícios",
  "obs.globalManaged": "Serviço compartilhado — gerido pelo operador da plataforma",
  "obs.actionsFor": "Solicitar uma ação para {service}",
  "obs.request": "Solicitar",
  "obs.confirmAction": "Solicitar “{action}” para {service}?",
  "obs.confirmBody": "A solicitação é registrada e aplicada pelo worker. O painel a mostra como solicitada até o serviço informar a mudança.",
  "obs.sendRequest": "Enviar solicitação",
  "obs.requestedNotApplied": "“{action}” solicitado para {service} — não aplicado",
  "obs.pendingWorker": "Solicitado, não aplicado: aplicar exige a função do worker app.runtime_apply_action, que está pendente.",
  "obs.operation": "Operação {id}",
  "obs.generatedAt": "Dados de {time}",
  "obs.logs": "Logs",
  "obs.exportCsv": "Exportar CSV",
  "obs.exportJson": "Exportar JSON",
  "obs.noProjects": "Nenhum projeto ainda",
  "obs.noProjectsBody": "Os logs são mantidos por projeto.",
  "obs.filters": "Filtros de log",
  "obs.levels": "Níveis",
  "obs.code": "Código",
  "obs.taskId": "ID da tarefa",
  "obs.search": "Buscar nas mensagens",
  "obs.apply": "Aplicar filtros",
  "obs.redactedNote": "Segredos são mascarados antes de os logs saírem do servidor. As exportações usam os mesmos filtros (até 1000 linhas).",
  "obs.noLogs": "Nenhum log corresponde a estes filtros.",
  "obs.time": "Horário",
  "obs.level": "Nível",
  "obs.message": "Mensagem",
  "obs.truncated": "truncado",
  "obs.openTrace": "Abrir rastro",
  "obs.loadMore": "Carregar mais",
  "obs.endOfLogs": "{n} registros — fim dos resultados.",
  "obs.traceTitle": "Rastro da tarefa",
  "obs.traceFor": "Rastro da tarefa",
  "obs.traceHint": "Abra um rastro a partir de um log ou informe o ID de uma tarefa.",
  "obs.taskIdInvalid": "Informe o ID de uma tarefa (UUID).",
  "runtimeAction.drain": "Drenar",
  "runtimeAction.resume": "Retomar",
  "runtimeAction.restart": "Reiniciar",
  "scope.global": "global",
  "scope.organization": "organização",
  "logLevel.debug": "Debug",
  "logLevel.info": "Info",
  "logLevel.warn": "Aviso",
  "logLevel.error": "Erro",
  "effective.configuration": "Configuração",
  "effective.activeConfig": "Configuração ativa",
  "effective.previewOf": "Pré-visualização da v{n} ({state})",
  "effective.previewHint": "A pré-visualização resolve um rascunho como se estivesse ativo; nada é ativado.",
  "effective.previewNotActive": "Somente pré-visualização — esta configuração não está ativa.",
  "infra.coolifyUpdated": "Conexão Coolify atualizada.",
  "infra.editBody": "Só os campos alterados são enviados. Mudar o acesso (host, usuário, autenticação, elevação ou fingerprint) devolve o servidor ao rascunho até ser validado de novo.",
  "infra.editCoolify": "Editar conexão Coolify",
  "infra.editTitle": "Editar “{name}”",
  "infra.noCoolify": "Nenhuma conexão Coolify para este servidor.",
  "infra.replace": "Substituir",
  "infra.set": "Definir",
  "infra.revoke": "Revogar",
  "infra.replaceSecret": "Substituir {name}",
  "infra.revokeSecret": "Revogar {name}",
  "infra.replaceTitle": "Substituir {name}",
  "infra.revokeTitle": "Revogar {name}?",
  "infra.replaceBody": "O novo valor é enviado uma vez e guardado no cofre; só o estado mascarado retorna. O servidor precisa ser validado de novo.",
  "infra.revokeBody": "A revogação vale imediatamente e o conteúdo cifrado é apagado; nunca é restaurado por reversão.",
  "infra.secretStored": "Segredo guardado. Só o estado mascarado é exibido.",
  "infra.secretRevoked": "Segredo revogado.",
  "infra.serverUpdated": "Servidor atualizado.",
  "infra.switchSecretHint": "Exigido pela nova configuração; credenciais que ela não usa mais são revogadas.",
  "infra.revalidationHint": "Os segredos são trocados individualmente no cartão do servidor.",
  "infra.webUserChangeHint": "Trocar o usuário revoga a senha web guardada.",
  "projectRouting.fullPreview": "Tabela efetiva completa após a ativação",
  "projectRouting.previewFailed": "Não foi possível resolver a pré-visualização",
  "quotas.byProject": "Participação na janela por projeto",
  "quotas.orgLevel": "Trabalho da organização",
  "quotas.tokensEstimated": "Tokens estimados",
  "quotas.usedShort": "Usadas",
  "runs.allProjects": "Todos os projetos",
  "runs.endOfList": "{n} tentativas — fim da lista.",
  "runs.rerun": "reexecução de uma tentativa anterior",
  "runs.stateFilter": "Estado",
  "trace.callsTruncated": "A lista mostra {n} de {total} chamadas; os totais de uso cobrem todas.",
  "usage.coverageComplete": "cobre todas as {total} chamadas",
  "usage.coverageTruncated": "cobre {n} de {total} chamadas",
  "attemptState.running": "Em execução",
  "attemptState.succeeded": "Concluída",
  "attemptState.failed": "Falhou",
  "attemptState.interrupted": "Interrompida",
  "attemptState.cancelled": "Cancelada",
  "attemptState.superseded": "Substituída",
  "attemptState.waiting_resource": "Aguardando recurso",
};
